import { getNeqFilter } from '../utils/filters';
export const FILTER_FEEDBACK_SURVEYS = getNeqFilter({
  property: 'hs_parent_source',
  value: 'FEEDBACK'
});
export const FILTER_WEB_INTERACTIVES_AI_GENERATION = getNeqFilter({
  property: 'hs_parent_source',
  value: 'WEB_INTERACTIVES_AI_GENERATION'
});
export const FILTER_VARIANTS = getNeqFilter({
  property: 'hs_personalization_variant_status',
  value: 'VARIANT'
});